// export const apiurl = 'https://arkmarketing.avark.biz';
export const apiurl = "https://skycast.avark.biz";
